import { defineMessages } from 'react-intl';

export default defineMessages({
  text: {
    id: 'cookiesBar.text',
    defaultMessage: 'By using our website you agree to our {link}.',
  },
  link: {
    id: 'cookiesBar.link',
    defaultMessage: 'use of cookies',
  },
  button: {
    id: 'cookiesBar.button',
    defaultMessage: 'I consent',
  },
});
